import { pick } from 'lodash'
import store from 'redux/store'
import { setRouterConfig, addToHistories } from 'redux/reducers/routerSlice'

import { RouterItemType } from 'router/type'
import { IRouterDomLocation } from './type.d'

export class RouterService {
  handleAfterRouteEnter(
    currentRoute: RouterItemType,
    location: IRouterDomLocation
  ): void {
    setTimeout((): void => {
      const item: any = pick(currentRoute, [
        'path',
        'exact',
        'isPrivate',
        'layout',
        'adminActiveMenuKey',
        'name'
      ])

      item.location = location
      store.dispatch(setRouterConfig(item))
      store.dispatch(addToHistories(item))
    })
  }
}
// eslint-disable-next-line
export default new RouterService()
